// App.tsx
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Home from "./Views/Home";
import Header from "./Components/Header";
import Popup from "./Components/Popup";
import MeetUs from "./Views/MeetUs";
import Services from "./Views/Services";
import PatientCenter from "./Views/PatientCenter";
import ContactUs from "./Views/ContactUs";
import Footer from "./Components/Footer";
import HealowCheckIn from "./Views/HealowCheckIn";

// service pages...
import ExpectingParents from "./Components/Services/ExpectantParents";
import WellChecks from "./Components/Services/WellChecks";
import SameDaySickVisits from "./Components/Services/SameDaySickVisits";
import FunctionalMedicine from "./Components/Services/FunctionalMedicine";
import CommonMedicalConditions from "./Components/Services/CommonMedicalConditions";

// patient center pages...
import NewPatient from "./Components/PatientCenter/NewPatient";
import PatientForms from "./Components/PatientCenter/PatientForms";
import RefillRequests from "./Components/PatientCenter/RefillRequests";
import OfficePolicies from "./Components/PatientCenter/OfficePolicies";
import FAQs from "./Components/PatientCenter/FAQs";

function App() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isPopupVisible, setIsPopupVisible] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const resp = await fetch("https://01s8aky6al.execute-api.us-east-2.amazonaws.com/dev/website");
        const result = await resp.json();
        const dataObject = result.reduce((acc, item) => {
          acc[item.configId] = item.data;
          return acc;
        }, {});
        setData(dataObject);

        if (dataObject.popupConfig) {
          setIsPopupVisible(dataObject.popupConfig.visible);
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const closePopup = () => setIsPopupVisible(false);

  // if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  // Put Router here, and delegate route-aware rendering to AppContent
  return (
    <Router>
      <AppContent
        data={data}
        isPopupVisible={isPopupVisible}
        closePopup={closePopup}
      />
    </Router>
  );
}

// This component can use useLocation because it's inside <Router>
function AppContent({ data, isPopupVisible, closePopup }) {
  const location = useLocation();
  const showHomePopup =
    location.pathname === "/" && data.popupConfig && isPopupVisible;

  return (
    <div className="bg-white min-h-screen">
      <Header />

      {showHomePopup && (
        <Popup
          visible={true}
          text={data.popupConfig.text}
          onClose={closePopup}
          previewMode={false}
        />
      )}

      <Routes>
        <Route path="/" element={<Home updates={data.whatsNewConfig?.updates || []} />} />
        <Route path="/meet-us" element={<MeetUs data={data.staffConfig} />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/expectant-parents" element={<ExpectingParents />} />
        <Route path="/services/well-checks" element={<WellChecks />} />
        <Route path="/services/same-day-sick-visits" element={<SameDaySickVisits />} />
        <Route path="/services/functional-medicine" element={<FunctionalMedicine />} />
        <Route path="/services/common-medical-conditions" element={<CommonMedicalConditions />} />
        <Route path="/patient-center" element={<PatientCenter />} />
        <Route path="/patient-center/new-patient" element={<NewPatient />} />
        <Route path="/patient-center/patient-forms" element={<PatientForms />} />
        <Route path="/patient-center/refill-requests" element={<RefillRequests />} />
        <Route path="/patient-center/office-policies" element={<OfficePolicies />} />
        <Route path="/patient-center/faqs" element={<FAQs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/checkIn" element={<HealowCheckIn />} />
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
